/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:1b4b3eca-b049-4e06-82e7-e2441bf1574c",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_n7Li3vgry",
    "aws_user_pools_web_client_id": "302mfr8fdookungpoppmfnfh7u",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "dahliahealth-20220718185515-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d3m9kmuzu6g4mn.cloudfront.net",
    "aws_user_files_s3_bucket": "dahliahealth-testimonials222135-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
